<template>
    <div class="rfqdetail">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>仓储</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>收货管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->

<!--&lt;!&ndash;            <el-page-header v-if="from == 'rfq'" @back="goBack" :content="'仓储订单详情('+ rfqId + ')'"></el-page-header>&ndash;&gt;-->
<!--&lt;!&ndash;            <el-breadcrumb v-if="from == 'menu'" separator="/">&ndash;&gt;-->
<!--&lt;!&ndash;                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>&ndash;&gt;-->
<!--&lt;!&ndash;                <el-breadcrumb-item>仓储</el-breadcrumb-item>&ndash;&gt;-->
<!--&lt;!&ndash;                <el-breadcrumb-item>报价录入</el-breadcrumb-item>&ndash;&gt;-->
<!--&lt;!&ndash;            </el-breadcrumb>&ndash;&gt;-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="商品名称">
                        <el-input v-model="searchForm.itemName" placeholder="商品名称" size="mini" clearable></el-input>
                    </el-form-item>


                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                 <el-table stripe
                    :data="tableData"
                    size="mini"
                    ref="detailTable"
                    v-loading="loading"
                    :height="tableConfig.height"
                    style="width: 100%">
                    <!-- <el-table-column v-if="$store.state.userInfo.review" type="selection" width="55"/> -->
                    <el-table-column
                        prop="itemSku"
                        label="编码"
                        width="180"
                        fixed="left"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="itemName"
                        label="名称"
                        width="350"
                        fixed="left"
                        >
                    </el-table-column>
                     <el-table-column
                        prop="itemNum"
                        label="数量"
                        width="100"
                        align="center"
                     >
                     </el-table-column>
                    <el-table-column
                        prop="itemUnit"
                        label="单位"
                        width="100"
                        align="center"
                        >
                    </el-table-column>
<!--                     <el-table-column-->
<!--                             prop="sendDay"-->
<!--                             label="货期(天)"-->
<!--                             width="100"-->
<!--                             align="center"-->
<!--                     >-->
<!--                     </el-table-column>-->
<!--                     <el-table-column-->
<!--                             prop="expireTime"-->
<!--                             label="价格有效期"-->
<!--                             width="120"-->
<!--                             align="center"-->
<!--                     >-->
<!--                     </el-table-column>-->

                     <el-table-column
                             prop="receiveNum"
                             label="到货数量"
                             width="100"
                             align="center"
                     />
                     <el-table-column

                            prop="status"
                            label="状态"
                            width="100" align="center">
                         <template slot-scope="scope">
                            <el-tag v-if="scope.row.process == 0">待分配业务员</el-tag>
                            <el-tag v-if="scope.row.process == 1">待分配供应商</el-tag>
                            <el-tag v-if="scope.row.process == 2">待供应商报价</el-tag>
                            <el-tag v-if="scope.row.process == 3">等待客服报价</el-tag>
                            <el-tag v-if="scope.row.process == 4">等待审核</el-tag>
                            <el-tag v-if="scope.row.process == 5">驳回</el-tag>
                            <el-tag v-if="scope.row.process == 6">已报价</el-tag>
                            <el-tag v-if="scope.row.process == 7">等待客户下单</el-tag>
                            <el-tag v-if="scope.row.process == 8">发货</el-tag>
                            <el-tag v-if="scope.row.process == 9">收货</el-tag>
                             <el-tag v-if="scope.row.process == 11">部分收货</el-tag>
                         </template>
                     </el-table-column>

                   <el-table-column label="操作" width="200" align="right" fixed="right">
                        <template slot="header">

                        </template>
                        <template slot-scope="scope">
<!--                            <el-button v-if="scope.row.process == 8 || scope.row.process == 11"-->
<!--                                       size="mini"-->
<!--                                       @click="onReceive(scope.row.id,11,scope.row.rfqId)">部分收货</el-button>-->
                        <el-button type="text" v-if="scope.row.process == 8 || scope.row.process == 11"
                                                                   size="mini"
                                                                   @click="handleHalf(scope.row)">部分收货</el-button>
                            <el-divider direction="vertical" v-if="scope.row.process == 8|| scope.row.process == 11"></el-divider>

                            <el-button v-if="scope.row.process == 8|| scope.row.process == 11"
                                size="mini" type="text"
                                @click="onReceive(scope.row.id,9,scope.row.rfqId)">收货</el-button>

                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :total="total"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="收货" :visible.sync="editDialogVisible" :before-close="handleClose" width="500px" close-on-click-modal>

            <el-form ref="editForm" :model="editForm" label-width="90px" :rules="rules">
                <el-form-item label="收货数量"  prop="receiveNum">
                    <el-input type="number" v-model="editForm.receiveNum" placeholder="请输入收到商品数量"
                               onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')" clearable
                    ></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onHalfReceive">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="商品报价信息导入" :visible.sync="importDialogVisible" width="500px">
            <el-form :model="editForm" label-width="80px">
                <el-form-item label="上传报价文件">
                    <el-upload
                            action="/api/admin/uploadFile"
                            accept=".xlsx"
                            :limit="1"
                            :before-upload="beforeUploadFile"
                            :on-change="fileChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList">
                        <el-button size="small" plain>选择文件</el-button>
                        <div slot="tip">只能上传xlsx(Excel2007)文件，且不超过10M</div>
                    </el-upload>
                    <el-input v-model="editForm.filePath" v-show="false" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="importDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onUploadSubmit">确 定</el-button>
            </div>
        </el-dialog>



    </div>
</template>
<script>
const HEIGHT_OFFSET = 118;
export default {
    data() {
        return {
            pageLoading: undefined,
            tableConfig: {
                height: 0,
            },
            searchForm: {
                itemId: "",
                itemName: "",
                itemPrice: "",
                buyerCode: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            importDialogVisible: false,
            editForm: {
                rfqId: "",
                rfqName: "",
                id: "",
                userId: null,
                itemId: "",
                itemName: "",
                itemPrice: "",
                answerPrice: "",
                itemSpecification: "",
                itemNum: "",
                receiveNum: "",
                itemUnit: "",
                remark: "",
                filePath: "",
                expireTime: "",
                sendDay: "",
            },
            staffs: [],//可选的派发的供应商

            editSupplier: false,
            editSupplierVisible: false,
            rules: {
                receiveNum: [
                    { required: true, message: '请输入收到的商品数量', trigger: 'blur' }
                ]
            }
        }
    },
    // props: ["from", "rfqId"],
    methods: {
        onSearch() {
            let rfq = {
            };
            if(this.searchForm.itemName != "") {
                rfq["itemName"] = this.searchForm.itemName;
            }
            let url = "/admin/rfq/storeDetail/search";

                this.loading = true;
                let _this = this
                this.$axios.post(url,{
                    cond: rfq,
                    page: this.currentPage - 1,size:this.pageSize
                }).then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        _this.loading = false;
                        _this.tableData = resp.data.content;
                        _this.total = resp.data.totalElements;
                    }
                }).catch(function() {
                });

        },
        handleCreate() {
            this.editForm.rfqId= this.rfqId;
            this.editForm.itemId = "";
            this.editForm.itemPrice = "";
            this.editForm.itemName = "";
            this.editDialogVisible = true;
        },
        handleCreateImport() {
            this.editForm.agreementId= this.agreementId;
            this.importDialogVisible = true;
        },
        onSubmit() {
            let url = "/admin/rfq/rfqdetail/save";
            let postData = this.editForm;

            let _this = this;
            this.$axios.post(url, postData)
            .then(function(response){
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.$notify({
                        title: '成功',
                        message: '数据保存成功',
                        type: 'success'
                    });
                    _this.editDialogVisible = false;
                    _this.onSearch();
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        },
        onUploadSubmit() {
            let _this = this;
            this.$axios.post("/admin/rfq/rfqdetail/onUploadSubmit", this.editForm)
            .then(function(response){
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.$notify({
                        title: '成功',
                        message: '数据保存成功',
                        type: 'success'
                    });
                    _this.importDialogVisible = false;
                    _this.onSearch();
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleEdit(index, row) {
            this.editForm.id = row.id;
            this.editForm.rfqId = row.rfqId;
            this.editForm.rfqName = row.rfqName;
            this.editForm.itemId = row.itemId;
            this.editForm.itemName = row.itemName;
            this.editForm.itemNum = row.itemNum;
            this.editForm.itemUnit = row.itemUnit;
            this.editForm.itemPrice = row.itemPrice;
            this.editForm.itemSpecification = row.itemSpecification;
            this.editForm.price = row.price;
            this.editForm.totalPrice = row.totalPrice;
            this.editForm.remark = row.remark;


                this.editDialogVisible = true;

        },


        // 文件状态改变时的钩子
        fileChange(file) {
            this.editForm.file = file.raw
        },
        // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
        beforeUploadFile(file) {
            let extension = file.name.substring(file.name.lastIndexOf('.')+1)
            let size = file.size / 1024 / 1024
            if(extension !== 'xlsx') {
                this.$notify.warning({
                    title: '警告',
                    message: `只能上传Excel2017（即后缀是.xlsx）的文件`
                });
            }
            if(size > 10) {
                this.$notify.warning({
                    title: '警告',
                    message: `文件大小不得超过10M`
                });
            }
        },
        // 文件上传成功时的钩子
        handleSuccess(res, file) {
            this.$notify.success({
                title: '成功',
                message: `文件上传成功`
            });
            if (file.response.data.success) {
                this.editForm.filePath = file.response.data.message; //将返回的文件储存路径赋值picture字段
            }
        },
        // 文件上传失败时的钩子
        handleError() {
            this.$notify.error({
                title: '错误',
                message: `文件上传失败`
            });
        },
        goBack() {
            this.$router.go(-1);

        },
        onSubmitPrice() {//提交报价
            let arr = this.$refs.detailTable.selection;

            if(arr.length == 0) {
                this.$notify.warning({
                    title: '提示',
                    message: "请先勾选报价单"
                });
                return;
            }
            for(let i=0; i<arr.length; i++){
                if(arr[i].price == null){
                    this.$notify.warning({
                        title: '提示',
                        message: "请先出价"
                    });
                    return;
                }
            }

            let _this = this;
            this.$confirm('是确认提交报价信息？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this.$axios.post("/admin/quote/updateQuote",{list:arr,status:2} )
                    .then(function(response) {
                        let resp = response.data;
                        if(resp.header.status === 0) {
                            _this.$notify({
                                title: '成功',
                                message: '提交报价成功',
                                type: 'success'
                            });

                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            })



        },
        handleClose() {},


        openSupplier() {
            if(this.$refs.detailTable.selection.length == 0){
                this.$notify.warning({
                    title: '提示',
                    message: "请先勾选询价单"
                });
            }else{
                this.editSupplier = true;
            }
        },
        onReceive(rfqDetailId,status,rfqId) {//收货 9 部分收货10

            let _this = this;
            let msg = '收货';
            if(status == 11){

                msg = '部分收货';
            }

            this.$confirm('是否确认'+msg+'？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this.$axios.post("/admin/rfq/saveGoodsProcess", {
                    rfqId: rfqId,
                    detailIds: [rfqDetailId],
                    process: status
                })
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status === 0) {
                            _this.$notify({
                                title: '成功',
                                message: msg+'成功',
                                type: 'success'
                            });
                            if(status == 9) {
                                _this.onCheck(rfqDetailId, rfqId);
                            }
                            _this.onSearch();

                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            })

        },
        onCheck(rfqDetailId,rfqId) {//收货


                this.$axios.post("/admin/rfq/checkGoodsProcess",{rfqId:rfqId,detailIds:[rfqDetailId],process:9} )
                    .then(function() {


                    });


        },
        handleHalf(row) {
            this.editForm.id = row.id;
            this.editForm.rfqId = row.rfqId;
            this.editForm.process = 11;
            this.editForm.receiveNum = "";
            this.editForm.itemNum = row.itemNum;
            this.editDialogVisible = true;

        },
        onHalfReceive() {
            this.$refs.editForm.validate(valid => {
                if (valid) {
                    if (this.editForm.receiveNum != "" && this.editForm.receiveNum > this.editForm.itemNum) {
                        this.$notify.error({
                            title: '错误',
                            message: "收货数量超过订单货物数量"
                        });
                        return;
                    }

                    let url = "/admin/rfq/saveGoodProcess";
                    let postData = {
                        rfqId: this.editForm.rfqId,
                        detailId: this.editForm.id,
                        process: 11, num: this.editForm.receiveNum
                    };
                    let _this = this;
                    this.$axios.post(url, postData)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                _this.editDialogVisible = false;
                                _this.onSearch();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                }
            })
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        }
    },
    created() {
        this.onSearch();
        window.addEventListener("resize", this.setTableHeight);
    },
    mounted() {
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 500);
    },
    beforeDestroy() {
        if(this.pageLoading){
            this.pageLoading.close();
            this.pageLoading = undefined;
        }
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    }
}
</script>
<style>

</style>